import { render, staticRenderFns } from "./activityOne.vue?vue&type=template&id=6e854268&scoped=true"
import script from "./activityOne.vue?vue&type=script&lang=js"
export * from "./activityOne.vue?vue&type=script&lang=js"
import style0 from "./activityOne.vue?vue&type=style&index=0&id=6e854268&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e854268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e854268')) {
      api.createRecord('6e854268', component.options)
    } else {
      api.reload('6e854268', component.options)
    }
    module.hot.accept("./activityOne.vue?vue&type=template&id=6e854268&scoped=true", function () {
      api.rerender('6e854268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/activityOne.vue"
export default component.exports